import React from 'react';
import { ThemedButton } from '../../themed/themed-button/ThemedButton';
import { observer } from 'mobx-react';
import { Heading3 } from '../../design-system/headings';
import { TextDefault } from '../../design-system/texts';
import { FlexDiv, Image } from '../../design-system/containers';
import { rgba } from 'polished';
import { resourcePath } from '../../../utils/helpers';
import DefaultTrans from '../default-i18next-trans';

function InstructionsOverlay({ closeModal, t }) {
    return (
        <FlexDiv
            backgroundColor={rgba(255, 255, 255, 0.97)}
            alignCenter
            column
            justifyCenter
            px={24}
            py={64}
            borderRadius={8}
            positionAbsolute
            expandFullyOverParent
            zIndex={2}
            minHeight={500}
        >
            <Image
                alt="envelope"
                src={resourcePath('/static/img/assessment/phishing.svg')}
            />
            <Heading3 mt={24}>{t('overlay_heading')}</Heading3>
            <FlexDiv mt={24}>
                <TextDefault>
                    <ul>
                        <li>
                            <DefaultTrans
                                translatedString={t('overlay_checkName')}
                            />
                        </li>
                        <li>
                            <DefaultTrans
                                translatedString={t('overlay_links')}
                            />
                        </li>
                    </ul>
                    <div>{t('overlay_paragraph')}</div>
                </TextDefault>
            </FlexDiv>
            <FlexDiv mt={24}>
                <ThemedButton
                    mode="secondary"
                    onClick={() => closeModal()}
                    text={t('Got it')}
                ></ThemedButton>
            </FlexDiv>
        </FlexDiv>
    );
}

export default observer(InstructionsOverlay);
